import { Vault } from '@/features/vaults/types';

export const ethereumDvstethVaultId = 'ethereum-dvsteth';

export const ethereumDvsteth: Vault = {
  id: ethereumDvstethVaultId,
  type: 'dvv-vault',
  name: 'Decentralized Validator Vault',
  description:
    'The Decentralized Validator Vault accepts ETH deposits to the Lido protocol, accelerating the adoption of Distributed Validator Technology (DVT) from Obol and SSV Network. Eligible vault users receive tokens from Obol and SSV, based on the number of DVT-based validators active in the Lido protocol. See the <a href="https://docs.mellow.finance/dvsteth-vault/overview" target="_blank">docs</a> for more info.',
  category: 'core-vault',
  address: '0x5E362eb2c0706Bd1d134689eC75176018385430B',
  curators: ['steakhouse'],
  operator: ['steakhouse'],
  points: [
    { entity: 'mellow', startTimestamp: 1722618479 },
    { entity: 'obol', startTimestamp: 1722618479, endTimestamp: 1745445600, show: false },
    { entity: 'ssv', startTimestamp: 1722618479, endTimestamp: 1745445600, show: false },
    { entity: 'merits', startTimestamp: 1737331211, endTimestamp: 1739746800 },
  ],
  layer: 'Lido Simple DVT',
  network: 'ethereum',
  baseToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
  lpTokenSymbol: 'DVstETH',
  lpTokenDecimals: 18,
  depositWrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
  depositTokens: [
    {
      address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
      decimals: 18,
      symbol: 'ETH',
      wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    },
    {
      address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      decimals: 18,
      symbol: 'WETH',
      wrapper: '0xfD4a4922d1AFe70000Ce0Ec6806454e78256504e',
    },
  ],
  tokenRewards: [
    {
      token: {
        network: 'ethereum',
        symbol: 'OBOL',
        address: '0x0B010000b7624eb9B3DfBC279673C76E9D29D5F7',
        decimals: 18,
      },
      startTimestamp: 1745445600,
      startClaimTimestamp: 1745964000,
      endTimestamp: 1777593600,
    },
    {
      token: {
        network: 'ethereum',
        symbol: 'SSV',
        address: '0x9D65fF81a3c488d585bBfb0Bfe3c7707c7917f54',
        decimals: 18,
      },
      startTimestamp: 1745445600,
      startClaimTimestamp: 1745445600,
      endTimestamp: 1777593600,
    },
  ],
  allocations: {
    showAllocationsTab: true,
  },
  displayOptions: {
    aprOrApy: 'APR',
  },
};
